import React, { useContext, useState, useCallback } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import useReactRouter from "use-react-router";
import { Typography, Paper, TextField, Grid, Fab } from "@material-ui/core";
import { LangContext } from "../Context/Langcontext";
import { getResetPassword } from "../API/Auth";
import { useSnackbar } from "notistack";

const useStyle = makeStyles((theme) => ({
  viewBg: {
    height: "100vh",
    backgroundColor: "#E5EAEE",
  },
  middle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  appbar: {
    display: "flex",
    position: "static",
    width: "85%",
    height: "5rem",
    alignItems: "center",
  },
  imageDesktop: {
    width: "auto",
    height: "3.5rem",
    marginLeft: "0.5rem",
    transition: ".5s",
    cursor: "pointer",
  },
  footer: {
    width: "85%",
    height: "3rem",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
  },
  symbol: {
    marginLeft: "2rem",
    color: "#595A5A",
    fontSize: "0.8rem",
    fontWeight: 200,
  },
  webtext: {
    color: "#595A5A",
    fontSize: "0.8rem",
    fontWeight: 200,
    margin: "0.5rem",
  },
  font: {
    color: "#595A5A",
    fontSize: "0.8rem",
    fontWeight: 400,
    cursor: "pointer",
  },
  body: {
    width: "70%",
    display: "flex",
    justifyContent: "center",
  },
  paper: {
    padding: "2rem",
    width: 480,
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
  },
  Resetfont: {
    fontSize: "1.3rem",
    textAlign: "center",
    color: "#595A5A",
  },
}));

const ResetPassword = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history, location } = useReactRouter();
  const { enqueueSnackbar } = useSnackbar();
  const [disable, setDisable] = useState(true);
  const [state, setState] = useState({
    password: "",
    confirm_password: "",
  });

  const [error, setError] = useState({
    statusPassword: false,
    password: "",
    statusCpassword: false,
    cpassword: "",
  });

  const validate = () => {
    let passwordError = "";
    let cpasswordlError = "";

    if (state.password.length < 8) {
      passwordError = lang.Password8;
    }

    if (state.password !== state.confirm_password) {
      cpasswordlError = lang.PasswordNotMatch;
    }

    if (cpasswordlError || passwordError) {
      setError({
        ...error,
        statusPassword: state.password.length < 8 ? true : false,
        password: state.password.length < 8 ? passwordError : "",
        statusCpassword:
          state.confirm_password !== state.password ? true : false,
        cpassword:
          state.confirm_password !== state.password ? cpasswordlError : "",
      });
      return false;
    }

    return true;
  };

  const onResetPassword = async () => {
    const isValid = validate();
    const searchText = location.search;
    const codeParam = new URLSearchParams(searchText).get("code");
    const emailParam = new URLSearchParams(searchText).get("email");
    const input = {
      email: emailParam,
      reset_code: codeParam,
      password: state.password,
    };
    if (isValid) {
      setDisable(true);
      const reset = await getResetPassword(input);
      if (reset.status.code === 200) {
        setDisable(false);
        history.replace("/user/login");
        enqueueSnackbar(lang.ResetPasswordSuccess, {
          variant: "success",
        });
      } else {
        setDisable(false);
        enqueueSnackbar(reset.status.message, {
          variant: "error",
        });
      }
    } else {
    }
  };

  const Resetpass = useCallback(async () => {
    const searchText = location.search;
    const codeParam = new URLSearchParams(searchText).get("code");
    // const emailParam = new URLSearchParams(searchText).get("email");
    // const input = { email: emailParam, reset_code: codeParam };

    if (typeof codeParam === "string") {
      // const active = await activateUser(input);
      // if (active.status.code === 200) {
      //   setTimeout(() => {
      //   }, 2000);
      // } else {
      //   setTimeout(() => {
      //   }, 2000);
      // }
    } else {
      history.replace("/user/login");
    }
  }, [location, history]);

  React.useEffect(() => {
    Resetpass();
    return () => {};
  }, [Resetpass]);

  React.useEffect(() => {
    document.title = `${lang.ResetPassword} | ${lang.MEAtitle}`;
    return () => {};
  }, [lang]);

  return (
    <div className={clsx(classes.middle, classes.viewBg)}>
      <div className={classes.appbar}>
        <img
          className={classes.imageDesktop}
          src={require("../images/LOGO/logo2.png")}
          alt="logo"
          onClick={() => {
            history.replace("/home");
            window.scrollTo(0, 0);
          }}
        />
      </div>
      <div className={classes.body}>
        <Paper className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography className={classes.Resetfont}>
                {lang.ResetYourPassword}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                id="outlined-name"
                label={lang.NewPassword}
                fullWidth
                className={classes.textfield}
                name="newpassword"
                type="password"
                value={state.password}
                onChange={(e) => {
                  setState({ ...state, password: e.target.value });
                  setDisable(false);
                  setError({ ...error, password: "", statusPassword: false });
                }}
                error={error.statusPassword}
                helperText={error.password}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                id="outlined-name"
                label={lang.ConfirmPassword}
                fullWidth
                className={classes.textfield}
                name="confirmpassword"
                type="password"
                onChange={(e) => {
                  setState({ ...state, confirm_password: e.target.value });
                  setError({ ...error, cpassword: "", statusCpassword: false });
                  setDisable(false);
                }}
                error={error.statusCpassword}
                helperText={error.cpassword}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Fab
                disabled={disable}
                variant="extended"
                aria-label="signin"
                color="primary"
                type="submit"
                style={{ boxShadow: "unset", textTransform: "unset" }}
                onClick={() => {
                  onResetPassword();
                }}
              >
                <Typography
                  variant="h6"
                  component="p"
                  style={{ color: "white", fontWeight: 400 }}
                >
                  {lang.ResetPassword}
                </Typography>
              </Fab>
            </Grid>
          </Grid>
        </Paper>
      </div>
      <div className={classes.footer}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography className={classes.symbol}>©</Typography>
          <Typography className={classes.webtext}>
            {`${
              langContext.lang.locale === "en"
                ? new Date().getFullYear()
                : Number(new Date().getFullYear() + 543)
            } ${lang.MEA}`}
          </Typography>
        </div>
        <div />
        <div
          style={{
            display: "flex",
            marginRight: "2rem",
            alignItems: "center",
          }}
        >
          <Typography
            className={classes.font}
            style={{
              marginRight: "1rem",
            }}
            onClick={() => {
              history.push("/terms");
            }}
          >
            {lang.Terms}
          </Typography>
          <Typography
            className={classes.font}
            onClick={() => {
              history.push("/privacy");
            }}
          >
            {lang.Privacy}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
